import { render, staticRenderFns } from "./casino-home-custom-banner.vue?vue&type=template&id=e074b7b2"
import script from "./casino-home-custom-banner.vue?vue&type=script&lang=js"
export * from "./casino-home-custom-banner.vue?vue&type=script&lang=js"
import style0 from "./casino-home-custom-banner.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/casino-home-custom-banner.vue
// module id = g14n
// module chunks = 0